import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from 'src/app/services/shared/user.service';
import { RoutingService } from '../../../services/routing.service';
import { ImpersonationService } from '../../../services/shared/impersonation.service';
import { InvestingEntityShareService } from '../../investing-entity-share/services/investing-entity-share.service';

@Component({
  selector: 'terra-lp-desktop-nav',
  templateUrl: './lp-desktop-nav.component.html',
  styleUrls: ['./lp-desktop-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpDesktopNavComponent implements OnInit {
  public covercyLogo = '/assets/images/logo/logo-dashboard.svg';

  referrerLogo$ = this.userService.lp_referrerLogo$;

  constructor(
    private router: Router,
    public routingService: RoutingService,
    private userService: UserService,
    private impersonationService: ImpersonationService,
    private readonly investmentingEntityShareService: InvestingEntityShareService
  ) {}

  ngOnInit(): void {}

  public get isViewingAsInvestor(): boolean {
    return this.impersonationService.isViewingAsInvestor;
  }

  forceReloadOnSamePage(relativePath: string) {
    if (relativePath === this.router.url) {
      window.location.reload();
      return false;
    }
  }

  share() {
    this.investmentingEntityShareService.openModal();
  }
}
